import { render, staticRenderFns } from "./ZoeziLink.vue?vue&type=template&id=29b27694"
import script from "./ZoeziLink.vue?vue&type=script&lang=js"
export * from "./ZoeziLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports